import { useEffect, useState } from "react";

export const CountUp = ({ value, decimals = 0, prefix = "", suffix = "" }) => {
  const [display, setDisplay] = useState(0);
  useEffect(() => {
    let start, raf;
    const dur = 1300;
    const step = (ts) => {
      if (!start) start = ts;
      const p = Math.min((ts - start) / dur, 1);
      const e = 1 - Math.pow(1 - p, 3);
      setDisplay(value * e);
      if (p < 1) raf = requestAnimationFrame(step);
    };
    raf = requestAnimationFrame(step);
    return () => cancelAnimationFrame(raf);
  }, [value]);
  const text = decimals > 0
    ? display.toLocaleString("it-IT", { minimumFractionDigits: decimals, maximumFractionDigits: decimals, useGrouping: "always" })
    : Math.floor(display).toLocaleString("it-IT", { useGrouping: "always" });
  return <>{prefix}{text}{suffix}</>;
};
